import { forwardRef, type ReactNode } from 'react';
import { FirmBranding } from '../../../../generated/graphql';
import { FIRM_BRANDING_DEFAULT_COLOR } from '../../../../Firm';

interface PresentationFirmLogoSidebarProps {
  firmBranding?: FirmBranding | null;
  children?: ReactNode;
  insightsEnabled?: boolean;
}

export const PresentationFirmLogoSidebar = forwardRef<HTMLImageElement, PresentationFirmLogoSidebarProps>(
  ({ firmBranding, children, insightsEnabled }, imageRef) => {
    return (
      <div
        className="z-10 flex h-full w-[544px] flex-col items-center justify-start p-[72px]"
        style={{
          backgroundColor: firmBranding?.color || FIRM_BRANDING_DEFAULT_COLOR,
        }}
      >
        {firmBranding?.logo && (
          <div
            className="h-auto w-auto rounded-2xl bg-white p-4"
            style={{ boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)' }}
          >
            <img
              ref={imageRef}
              alt="Firm's Logo"
              crossOrigin="anonymous"
              src={firmBranding.logo?.downloadURL || ''}
              style={insightsEnabled ? { maxHeight: 140, objectFit: 'contain' } : undefined}
            />
          </div>
        )}
        {children}
      </div>
    );
  }
);
